import type { HTMLAttributes } from 'react'
import { cn } from '@/lib/utils'

export function Container({
  className,
  children,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('mx-auto w-full max-w-7xl px-4 md:px-6', className)}
      {...props}
    >
      {children}
    </div>
  )
}
